// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__eDVMk","action":"page_action__oQqol","scroll":"page_scroll__9Mbyd","item":"page_item__KR6gQ"};